import React, { useState } from "react";
import CardInput from "../../components/CardInput";
import { callAPI } from "../../utils";
import { getCreateCreditTokenUrl } from "../shared/createCreditToken.utils";
import {
  buildAvisRequest,
  getAvisFormConfig,
  getAvisSuccessUrl,
} from "./Avis.utils";

const errorMessage = (response, fallback = "Unable to add AVIS card.") =>
  response?.response?.message ?? response?.message ?? fallback;

export default function Avis(props) {
  const { alert, setIsLoading } = props;
  const [isUnionPay, setIsUnionPay] = useState(false);
  const [pendingForm, setPendingForm] = useState(null);
  const [verificationCode, setVerificationCode] = useState("");

  const checkUnionPay = async (cardNumber) => {
    if (!cardNumber) return;
    try {
      const result = await callAPI(
        `${process.env.REACT_APP_WEBHOOK_API_ENDPOINT}/api/webhook/checkUnionpayCard`,
        "POST",
        { fleetId: props.fleetId, cardNumber }
      );
      setIsUnionPay(Boolean(result?.response));
    } catch (error) {
      alert(error?.message ?? "Unable to identify the card type.");
    }
  };

  const complete = () => {
    const successUrl = getAvisSuccessUrl(props);
    if (!successUrl) throw new Error("AVIS success redirect URL is missing.");
    window.location.assign(successUrl);
  };

  const submit = async (formData, code) => {
    setIsLoading(true);
    try {
      const response = await callAPI(
        getCreateCreditTokenUrl(
          process.env.REACT_APP_WEBHOOK_API_ENDPOINT,
          props.userType
        ),
        "POST",
        buildAvisRequest(formData, props, code)
      );
      if (response?.returnCode === 457) {
        setPendingForm(formData);
        return;
      }
      if (response?.returnCode !== 200) {
        throw new Error(errorMessage(response));
      }
      complete();
    } catch (error) {
      alert(
        error?.response?.data?.response?.message ??
          error?.response?.data?.message ??
          error?.message ??
          "Unable to add AVIS card."
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (pendingForm) {
    return (
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submit(pendingForm, verificationCode);
        }}
      >
        <label>
          Verification code <span className="required">*</span>
        </label>
        <input
          value={verificationCode}
          onChange={(event) => setVerificationCode(event.target.value)}
          required
          inputMode="numeric"
          autoComplete="one-time-code"
        />
        <input type="submit" value="Verify" />
      </form>
    );
  }

  return (
    <CardInput
      onSubmit={(formData) => submit(formData)}
      onCardNumberBlur={checkUnionPay}
      configGateway={getAvisFormConfig(props, isUnionPay)}
    />
  );
}
